/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */


import ApiClient from "../ApiClient";
import LogControllerDtoAccountHolderChangeLogListRequest from '../model/LogControllerDtoAccountHolderChangeLogListRequest';
import LogControllerDtoAccountHolderChangeLogListResponse from '../model/LogControllerDtoAccountHolderChangeLogListResponse';
import LogControllerDtoAccountLoginLogListRequest from '../model/LogControllerDtoAccountLoginLogListRequest';
import LogControllerDtoAccountLoginLogListResponse from '../model/LogControllerDtoAccountLoginLogListResponse';
import LogControllerDtoAccountSessionLogListRequest from '../model/LogControllerDtoAccountSessionLogListRequest';
import LogControllerDtoAccountSessionLogListResponse from '../model/LogControllerDtoAccountSessionLogListResponse';
import LogControllerDtoBreedLogListRequest from '../model/LogControllerDtoBreedLogListRequest';
import LogControllerDtoBreedLogListResponse from '../model/LogControllerDtoBreedLogListResponse';
import LogControllerDtoCommonSafetyCodeLogListRequest from '../model/LogControllerDtoCommonSafetyCodeLogListRequest';
import LogControllerDtoCommonSafetyCodeLogListResponse from '../model/LogControllerDtoCommonSafetyCodeLogListResponse';
import LogControllerDtoEvolveLogListRequest from '../model/LogControllerDtoEvolveLogListRequest';
import LogControllerDtoEvolveLogListResponse from '../model/LogControllerDtoEvolveLogListResponse';
import LogControllerDtoGamePlaySessionLogListRequest from '../model/LogControllerDtoGamePlaySessionLogListRequest';
import LogControllerDtoGamePlaySessionLogListResponse from '../model/LogControllerDtoGamePlaySessionLogListResponse';
import LogControllerDtoGearMiningLogListRequest from '../model/LogControllerDtoGearMiningLogListRequest';
import LogControllerDtoGearMiningLogListResponse from '../model/LogControllerDtoGearMiningLogListResponse';
import LogControllerDtoGemSocketUpdateLogListRequest from '../model/LogControllerDtoGemSocketUpdateLogListRequest';
import LogControllerDtoGemSocketUpdateLogListResponse from '../model/LogControllerDtoGemSocketUpdateLogListResponse';
import LogControllerDtoGoogleStorePurchaseLogListRequest from '../model/LogControllerDtoGoogleStorePurchaseLogListRequest';
import LogControllerDtoGoogleStorePurchaseLogListResponse from '../model/LogControllerDtoGoogleStorePurchaseLogListResponse';
import LogControllerDtoInventoryTransactionLogListRequest from '../model/LogControllerDtoInventoryTransactionLogListRequest';
import LogControllerDtoInventoryTransactionLogListResponse from '../model/LogControllerDtoInventoryTransactionLogListResponse';
import LogControllerDtoItemBoxOpenLogListRequest from '../model/LogControllerDtoItemBoxOpenLogListRequest';
import LogControllerDtoItemBoxOpenLogListResponse from '../model/LogControllerDtoItemBoxOpenLogListResponse';
import LogControllerDtoItemShopPurchaseLogListRequest from '../model/LogControllerDtoItemShopPurchaseLogListRequest';
import LogControllerDtoItemShopPurchaseLogListResponse from '../model/LogControllerDtoItemShopPurchaseLogListResponse';
import LogControllerDtoItemTransactionLogListRequest from '../model/LogControllerDtoItemTransactionLogListRequest';
import LogControllerDtoItemTransactionLogListResponse from '../model/LogControllerDtoItemTransactionLogListResponse';
import LogControllerDtoLevelUpLogListRequest from '../model/LogControllerDtoLevelUpLogListRequest';
import LogControllerDtoLevelUpLogListResponse from '../model/LogControllerDtoLevelUpLogListResponse';
import LogControllerDtoMarketCarBoxTransactionLogListRequest from '../model/LogControllerDtoMarketCarBoxTransactionLogListRequest';
import LogControllerDtoMarketCarBoxTransactionLogListResponse from '../model/LogControllerDtoMarketCarBoxTransactionLogListResponse';
import LogControllerDtoMarketCarTransactionLogListRequest from '../model/LogControllerDtoMarketCarTransactionLogListRequest';
import LogControllerDtoMarketCarTransactionLogListResponse from '../model/LogControllerDtoMarketCarTransactionLogListResponse';
import LogControllerDtoMarketGemTransactionLogListRequest from '../model/LogControllerDtoMarketGemTransactionLogListRequest';
import LogControllerDtoMarketGemTransactionLogListResponse from '../model/LogControllerDtoMarketGemTransactionLogListResponse';
import LogControllerDtoMarketItemTransactionLogListRequest from '../model/LogControllerDtoMarketItemTransactionLogListRequest';
import LogControllerDtoMarketItemTransactionLogListResponse from '../model/LogControllerDtoMarketItemTransactionLogListResponse';
import LogControllerDtoMarketPilotTransactionLogListRequest from '../model/LogControllerDtoMarketPilotTransactionLogListRequest';
import LogControllerDtoMarketPilotTransactionLogListResponse from '../model/LogControllerDtoMarketPilotTransactionLogListResponse';
import LogControllerDtoMissionFreeLogListRequest from '../model/LogControllerDtoMissionFreeLogListRequest';
import LogControllerDtoMissionFreeLogListResponse from '../model/LogControllerDtoMissionFreeLogListResponse';
import LogControllerDtoNftDisassembleLogListRequest from '../model/LogControllerDtoNftDisassembleLogListRequest';
import LogControllerDtoNftDisassembleLogListResponse from '../model/LogControllerDtoNftDisassembleLogListResponse';
import LogControllerDtoNftRepairLogListRequest from '../model/LogControllerDtoNftRepairLogListRequest';
import LogControllerDtoNftRepairLogListResponse from '../model/LogControllerDtoNftRepairLogListResponse';
import LogControllerDtoNftRestoreLogListRequest from '../model/LogControllerDtoNftRestoreLogListRequest';
import LogControllerDtoNftRestoreLogListResponse from '../model/LogControllerDtoNftRestoreLogListResponse';
import LogControllerDtoNftStoredPowersLogListRequest from '../model/LogControllerDtoNftStoredPowersLogListRequest';
import LogControllerDtoNftStoredPowersLogListResponse from '../model/LogControllerDtoNftStoredPowersLogListResponse';
import LogControllerDtoNftTransactionLogListRequest from '../model/LogControllerDtoNftTransactionLogListRequest';
import LogControllerDtoNftTransactionLogListResponse from '../model/LogControllerDtoNftTransactionLogListResponse';
import LogControllerDtoNicknameChangeLogListRequest from '../model/LogControllerDtoNicknameChangeLogListRequest';
import LogControllerDtoNicknameChangeLogListResponse from '../model/LogControllerDtoNicknameChangeLogListResponse';
import LogControllerDtoPilotDisassembleLogListRequest from '../model/LogControllerDtoPilotDisassembleLogListRequest';
import LogControllerDtoPilotDisassembleLogListResponse from '../model/LogControllerDtoPilotDisassembleLogListResponse';
import LogControllerDtoPilotEquipLogListRequest from '../model/LogControllerDtoPilotEquipLogListRequest';
import LogControllerDtoPilotEquipLogListResponse from '../model/LogControllerDtoPilotEquipLogListResponse';
import LogControllerDtoPilotPromotionLogListRequest from '../model/LogControllerDtoPilotPromotionLogListRequest';
import LogControllerDtoPilotPromotionLogListResponse from '../model/LogControllerDtoPilotPromotionLogListResponse';
import LogControllerDtoPilotSkillChangeLogListRequest from '../model/LogControllerDtoPilotSkillChangeLogListRequest';
import LogControllerDtoPilotSkillChangeLogListResponse from '../model/LogControllerDtoPilotSkillChangeLogListResponse';
import LogControllerDtoPowerChargeLogListRequest from '../model/LogControllerDtoPowerChargeLogListRequest';
import LogControllerDtoPowerChargeLogListResponse from '../model/LogControllerDtoPowerChargeLogListResponse';
import LogControllerDtoResetStatsLogListRequest from '../model/LogControllerDtoResetStatsLogListRequest';
import LogControllerDtoResetStatsLogListResponse from '../model/LogControllerDtoResetStatsLogListResponse';
import LogControllerDtoRollRandomGemSocketsLogListRequest from '../model/LogControllerDtoRollRandomGemSocketsLogListRequest';
import LogControllerDtoRollRandomGemSocketsLogListResponse from '../model/LogControllerDtoRollRandomGemSocketsLogListResponse';
import LogControllerDtoSpecialBoxLogListRequest from '../model/LogControllerDtoSpecialBoxLogListRequest';
import LogControllerDtoSpecialBoxLogListResponse from '../model/LogControllerDtoSpecialBoxLogListResponse';
import LogControllerDtoTransactionAttemptLogListRequest from '../model/LogControllerDtoTransactionAttemptLogListRequest';
import LogControllerDtoTransactionAttemptLogListResponse from '../model/LogControllerDtoTransactionAttemptLogListResponse';
import LogControllerDtoWalletConnectionLogListRequest from '../model/LogControllerDtoWalletConnectionLogListRequest';
import LogControllerDtoWalletConnectionLogListResponse from '../model/LogControllerDtoWalletConnectionLogListResponse';
import LogControllerDtoWalletTransactionLogListRequest from '../model/LogControllerDtoWalletTransactionLogListRequest';
import LogControllerDtoWalletTransactionLogListResponse from '../model/LogControllerDtoWalletTransactionLogListResponse';

/**
* PerplayLog service.
* @module api/PerplayLogApi
* @version 1.0
*/
export default class PerplayLogApi {

    /**
    * Constructs a new PerplayLogApi. 
    * @alias module:api/PerplayLogApi
    * @class
    * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
    * default to {@link module:ApiClient#instance} if unspecified.
    */
    constructor(apiClient) {
        this.apiClient = apiClient || ApiClient.instance;
    }


    /**
     * Callback function to receive the result of the apiPerplayLogAccountHolderChangeLogListPost operation.
     * @callback module:api/PerplayLogApi~apiPerplayLogAccountHolderChangeLogListPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/LogControllerDtoAccountHolderChangeLogListResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/LogControllerDtoAccountHolderChangeLogListRequest} [logControllerDtoAccountHolderChangeLogListRequest] 
     * @param {module:api/PerplayLogApi~apiPerplayLogAccountHolderChangeLogListPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/LogControllerDtoAccountHolderChangeLogListResponse}
     */
    apiPerplayLogAccountHolderChangeLogListPost(opts, callback) {
      opts = opts || {};
      let postBody = opts['logControllerDtoAccountHolderChangeLogListRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = LogControllerDtoAccountHolderChangeLogListResponse;
      return this.apiClient.callApi(
        '/api/PerplayLog/AccountHolderChangeLogList', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiPerplayLogAccountLoginLogListPost operation.
     * @callback module:api/PerplayLogApi~apiPerplayLogAccountLoginLogListPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/LogControllerDtoAccountLoginLogListResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/LogControllerDtoAccountLoginLogListRequest} [logControllerDtoAccountLoginLogListRequest] 
     * @param {module:api/PerplayLogApi~apiPerplayLogAccountLoginLogListPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/LogControllerDtoAccountLoginLogListResponse}
     */
    apiPerplayLogAccountLoginLogListPost(opts, callback) {
      opts = opts || {};
      let postBody = opts['logControllerDtoAccountLoginLogListRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = LogControllerDtoAccountLoginLogListResponse;
      return this.apiClient.callApi(
        '/api/PerplayLog/AccountLoginLogList', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiPerplayLogAccountSessionLogListPost operation.
     * @callback module:api/PerplayLogApi~apiPerplayLogAccountSessionLogListPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/LogControllerDtoAccountSessionLogListResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/LogControllerDtoAccountSessionLogListRequest} [logControllerDtoAccountSessionLogListRequest] 
     * @param {module:api/PerplayLogApi~apiPerplayLogAccountSessionLogListPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/LogControllerDtoAccountSessionLogListResponse}
     */
    apiPerplayLogAccountSessionLogListPost(opts, callback) {
      opts = opts || {};
      let postBody = opts['logControllerDtoAccountSessionLogListRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = LogControllerDtoAccountSessionLogListResponse;
      return this.apiClient.callApi(
        '/api/PerplayLog/AccountSessionLogList', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiPerplayLogBreedLogListPost operation.
     * @callback module:api/PerplayLogApi~apiPerplayLogBreedLogListPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/LogControllerDtoBreedLogListResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/LogControllerDtoBreedLogListRequest} [logControllerDtoBreedLogListRequest] 
     * @param {module:api/PerplayLogApi~apiPerplayLogBreedLogListPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/LogControllerDtoBreedLogListResponse}
     */
    apiPerplayLogBreedLogListPost(opts, callback) {
      opts = opts || {};
      let postBody = opts['logControllerDtoBreedLogListRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = LogControllerDtoBreedLogListResponse;
      return this.apiClient.callApi(
        '/api/PerplayLog/BreedLogList', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiPerplayLogCommonSafetyCodeLogListPost operation.
     * @callback module:api/PerplayLogApi~apiPerplayLogCommonSafetyCodeLogListPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/LogControllerDtoCommonSafetyCodeLogListResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/LogControllerDtoCommonSafetyCodeLogListRequest} [logControllerDtoCommonSafetyCodeLogListRequest] 
     * @param {module:api/PerplayLogApi~apiPerplayLogCommonSafetyCodeLogListPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/LogControllerDtoCommonSafetyCodeLogListResponse}
     */
    apiPerplayLogCommonSafetyCodeLogListPost(opts, callback) {
      opts = opts || {};
      let postBody = opts['logControllerDtoCommonSafetyCodeLogListRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = LogControllerDtoCommonSafetyCodeLogListResponse;
      return this.apiClient.callApi(
        '/api/PerplayLog/CommonSafetyCodeLogList', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiPerplayLogEvolveLogListPost operation.
     * @callback module:api/PerplayLogApi~apiPerplayLogEvolveLogListPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/LogControllerDtoEvolveLogListResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/LogControllerDtoEvolveLogListRequest} [logControllerDtoEvolveLogListRequest] 
     * @param {module:api/PerplayLogApi~apiPerplayLogEvolveLogListPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/LogControllerDtoEvolveLogListResponse}
     */
    apiPerplayLogEvolveLogListPost(opts, callback) {
      opts = opts || {};
      let postBody = opts['logControllerDtoEvolveLogListRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = LogControllerDtoEvolveLogListResponse;
      return this.apiClient.callApi(
        '/api/PerplayLog/EvolveLogList', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiPerplayLogGamePlaySessionLogListPost operation.
     * @callback module:api/PerplayLogApi~apiPerplayLogGamePlaySessionLogListPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/LogControllerDtoGamePlaySessionLogListResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/LogControllerDtoGamePlaySessionLogListRequest} [logControllerDtoGamePlaySessionLogListRequest] 
     * @param {module:api/PerplayLogApi~apiPerplayLogGamePlaySessionLogListPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/LogControllerDtoGamePlaySessionLogListResponse}
     */
    apiPerplayLogGamePlaySessionLogListPost(opts, callback) {
      opts = opts || {};
      let postBody = opts['logControllerDtoGamePlaySessionLogListRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = LogControllerDtoGamePlaySessionLogListResponse;
      return this.apiClient.callApi(
        '/api/PerplayLog/GamePlaySessionLogList', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiPerplayLogGearMiningLogListPost operation.
     * @callback module:api/PerplayLogApi~apiPerplayLogGearMiningLogListPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/LogControllerDtoGearMiningLogListResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/LogControllerDtoGearMiningLogListRequest} [logControllerDtoGearMiningLogListRequest] 
     * @param {module:api/PerplayLogApi~apiPerplayLogGearMiningLogListPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/LogControllerDtoGearMiningLogListResponse}
     */
    apiPerplayLogGearMiningLogListPost(opts, callback) {
      opts = opts || {};
      let postBody = opts['logControllerDtoGearMiningLogListRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = LogControllerDtoGearMiningLogListResponse;
      return this.apiClient.callApi(
        '/api/PerplayLog/GearMiningLogList', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiPerplayLogGemSocketUpdateLogListPost operation.
     * @callback module:api/PerplayLogApi~apiPerplayLogGemSocketUpdateLogListPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/LogControllerDtoGemSocketUpdateLogListResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/LogControllerDtoGemSocketUpdateLogListRequest} [logControllerDtoGemSocketUpdateLogListRequest] 
     * @param {module:api/PerplayLogApi~apiPerplayLogGemSocketUpdateLogListPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/LogControllerDtoGemSocketUpdateLogListResponse}
     */
    apiPerplayLogGemSocketUpdateLogListPost(opts, callback) {
      opts = opts || {};
      let postBody = opts['logControllerDtoGemSocketUpdateLogListRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = LogControllerDtoGemSocketUpdateLogListResponse;
      return this.apiClient.callApi(
        '/api/PerplayLog/GemSocketUpdateLogList', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiPerplayLogGoogleStorePurchaseLogListPost operation.
     * @callback module:api/PerplayLogApi~apiPerplayLogGoogleStorePurchaseLogListPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/LogControllerDtoGoogleStorePurchaseLogListResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/LogControllerDtoGoogleStorePurchaseLogListRequest} [logControllerDtoGoogleStorePurchaseLogListRequest] 
     * @param {module:api/PerplayLogApi~apiPerplayLogGoogleStorePurchaseLogListPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/LogControllerDtoGoogleStorePurchaseLogListResponse}
     */
    apiPerplayLogGoogleStorePurchaseLogListPost(opts, callback) {
      opts = opts || {};
      let postBody = opts['logControllerDtoGoogleStorePurchaseLogListRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = LogControllerDtoGoogleStorePurchaseLogListResponse;
      return this.apiClient.callApi(
        '/api/PerplayLog/GoogleStorePurchaseLogList', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiPerplayLogInventoryTransactionLogListPost operation.
     * @callback module:api/PerplayLogApi~apiPerplayLogInventoryTransactionLogListPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/LogControllerDtoInventoryTransactionLogListResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/LogControllerDtoInventoryTransactionLogListRequest} [logControllerDtoInventoryTransactionLogListRequest] 
     * @param {module:api/PerplayLogApi~apiPerplayLogInventoryTransactionLogListPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/LogControllerDtoInventoryTransactionLogListResponse}
     */
    apiPerplayLogInventoryTransactionLogListPost(opts, callback) {
      opts = opts || {};
      let postBody = opts['logControllerDtoInventoryTransactionLogListRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = LogControllerDtoInventoryTransactionLogListResponse;
      return this.apiClient.callApi(
        '/api/PerplayLog/InventoryTransactionLogList', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiPerplayLogItemBoxOpenLogListPost operation.
     * @callback module:api/PerplayLogApi~apiPerplayLogItemBoxOpenLogListPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/LogControllerDtoItemBoxOpenLogListResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/LogControllerDtoItemBoxOpenLogListRequest} [logControllerDtoItemBoxOpenLogListRequest] 
     * @param {module:api/PerplayLogApi~apiPerplayLogItemBoxOpenLogListPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/LogControllerDtoItemBoxOpenLogListResponse}
     */
    apiPerplayLogItemBoxOpenLogListPost(opts, callback) {
      opts = opts || {};
      let postBody = opts['logControllerDtoItemBoxOpenLogListRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = LogControllerDtoItemBoxOpenLogListResponse;
      return this.apiClient.callApi(
        '/api/PerplayLog/ItemBoxOpenLogList', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiPerplayLogItemShopPurchaseLogListPost operation.
     * @callback module:api/PerplayLogApi~apiPerplayLogItemShopPurchaseLogListPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/LogControllerDtoItemShopPurchaseLogListResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/LogControllerDtoItemShopPurchaseLogListRequest} [logControllerDtoItemShopPurchaseLogListRequest] 
     * @param {module:api/PerplayLogApi~apiPerplayLogItemShopPurchaseLogListPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/LogControllerDtoItemShopPurchaseLogListResponse}
     */
    apiPerplayLogItemShopPurchaseLogListPost(opts, callback) {
      opts = opts || {};
      let postBody = opts['logControllerDtoItemShopPurchaseLogListRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = LogControllerDtoItemShopPurchaseLogListResponse;
      return this.apiClient.callApi(
        '/api/PerplayLog/ItemShopPurchaseLogList', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiPerplayLogItemTransactionLogListPost operation.
     * @callback module:api/PerplayLogApi~apiPerplayLogItemTransactionLogListPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/LogControllerDtoItemTransactionLogListResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/LogControllerDtoItemTransactionLogListRequest} [logControllerDtoItemTransactionLogListRequest] 
     * @param {module:api/PerplayLogApi~apiPerplayLogItemTransactionLogListPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/LogControllerDtoItemTransactionLogListResponse}
     */
    apiPerplayLogItemTransactionLogListPost(opts, callback) {
      opts = opts || {};
      let postBody = opts['logControllerDtoItemTransactionLogListRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = LogControllerDtoItemTransactionLogListResponse;
      return this.apiClient.callApi(
        '/api/PerplayLog/ItemTransactionLogList', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiPerplayLogLevelUpLogListPost operation.
     * @callback module:api/PerplayLogApi~apiPerplayLogLevelUpLogListPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/LogControllerDtoLevelUpLogListResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/LogControllerDtoLevelUpLogListRequest} [logControllerDtoLevelUpLogListRequest] 
     * @param {module:api/PerplayLogApi~apiPerplayLogLevelUpLogListPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/LogControllerDtoLevelUpLogListResponse}
     */
    apiPerplayLogLevelUpLogListPost(opts, callback) {
      opts = opts || {};
      let postBody = opts['logControllerDtoLevelUpLogListRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = LogControllerDtoLevelUpLogListResponse;
      return this.apiClient.callApi(
        '/api/PerplayLog/LevelUpLogList', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiPerplayLogMarketCarBoxTransactionLogListPost operation.
     * @callback module:api/PerplayLogApi~apiPerplayLogMarketCarBoxTransactionLogListPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/LogControllerDtoMarketCarBoxTransactionLogListResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/LogControllerDtoMarketCarBoxTransactionLogListRequest} [logControllerDtoMarketCarBoxTransactionLogListRequest] 
     * @param {module:api/PerplayLogApi~apiPerplayLogMarketCarBoxTransactionLogListPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/LogControllerDtoMarketCarBoxTransactionLogListResponse}
     */
    apiPerplayLogMarketCarBoxTransactionLogListPost(opts, callback) {
      opts = opts || {};
      let postBody = opts['logControllerDtoMarketCarBoxTransactionLogListRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = LogControllerDtoMarketCarBoxTransactionLogListResponse;
      return this.apiClient.callApi(
        '/api/PerplayLog/MarketCarBoxTransactionLogList', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiPerplayLogMarketCarTransactionLogListPost operation.
     * @callback module:api/PerplayLogApi~apiPerplayLogMarketCarTransactionLogListPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/LogControllerDtoMarketCarTransactionLogListResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/LogControllerDtoMarketCarTransactionLogListRequest} [logControllerDtoMarketCarTransactionLogListRequest] 
     * @param {module:api/PerplayLogApi~apiPerplayLogMarketCarTransactionLogListPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/LogControllerDtoMarketCarTransactionLogListResponse}
     */
    apiPerplayLogMarketCarTransactionLogListPost(opts, callback) {
      opts = opts || {};
      let postBody = opts['logControllerDtoMarketCarTransactionLogListRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = LogControllerDtoMarketCarTransactionLogListResponse;
      return this.apiClient.callApi(
        '/api/PerplayLog/MarketCarTransactionLogList', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiPerplayLogMarketGemTransactionLogListPost operation.
     * @callback module:api/PerplayLogApi~apiPerplayLogMarketGemTransactionLogListPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/LogControllerDtoMarketGemTransactionLogListResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/LogControllerDtoMarketGemTransactionLogListRequest} [logControllerDtoMarketGemTransactionLogListRequest] 
     * @param {module:api/PerplayLogApi~apiPerplayLogMarketGemTransactionLogListPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/LogControllerDtoMarketGemTransactionLogListResponse}
     */
    apiPerplayLogMarketGemTransactionLogListPost(opts, callback) {
      opts = opts || {};
      let postBody = opts['logControllerDtoMarketGemTransactionLogListRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = LogControllerDtoMarketGemTransactionLogListResponse;
      return this.apiClient.callApi(
        '/api/PerplayLog/MarketGemTransactionLogList', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiPerplayLogMarketItemTransactionLogListPost operation.
     * @callback module:api/PerplayLogApi~apiPerplayLogMarketItemTransactionLogListPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/LogControllerDtoMarketItemTransactionLogListResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/LogControllerDtoMarketItemTransactionLogListRequest} [logControllerDtoMarketItemTransactionLogListRequest] 
     * @param {module:api/PerplayLogApi~apiPerplayLogMarketItemTransactionLogListPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/LogControllerDtoMarketItemTransactionLogListResponse}
     */
    apiPerplayLogMarketItemTransactionLogListPost(opts, callback) {
      opts = opts || {};
      let postBody = opts['logControllerDtoMarketItemTransactionLogListRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = LogControllerDtoMarketItemTransactionLogListResponse;
      return this.apiClient.callApi(
        '/api/PerplayLog/MarketItemTransactionLogList', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiPerplayLogMarketPilotTransactionLogListPost operation.
     * @callback module:api/PerplayLogApi~apiPerplayLogMarketPilotTransactionLogListPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/LogControllerDtoMarketPilotTransactionLogListResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/LogControllerDtoMarketPilotTransactionLogListRequest} [logControllerDtoMarketPilotTransactionLogListRequest] 
     * @param {module:api/PerplayLogApi~apiPerplayLogMarketPilotTransactionLogListPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/LogControllerDtoMarketPilotTransactionLogListResponse}
     */
    apiPerplayLogMarketPilotTransactionLogListPost(opts, callback) {
      opts = opts || {};
      let postBody = opts['logControllerDtoMarketPilotTransactionLogListRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = LogControllerDtoMarketPilotTransactionLogListResponse;
      return this.apiClient.callApi(
        '/api/PerplayLog/MarketPilotTransactionLogList', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiPerplayLogMissionFreeLogListPost operation.
     * @callback module:api/PerplayLogApi~apiPerplayLogMissionFreeLogListPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/LogControllerDtoMissionFreeLogListResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/LogControllerDtoMissionFreeLogListRequest} [logControllerDtoMissionFreeLogListRequest] 
     * @param {module:api/PerplayLogApi~apiPerplayLogMissionFreeLogListPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/LogControllerDtoMissionFreeLogListResponse}
     */
    apiPerplayLogMissionFreeLogListPost(opts, callback) {
      opts = opts || {};
      let postBody = opts['logControllerDtoMissionFreeLogListRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = LogControllerDtoMissionFreeLogListResponse;
      return this.apiClient.callApi(
        '/api/PerplayLog/MissionFreeLogList', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiPerplayLogNftDisassembleLogListPost operation.
     * @callback module:api/PerplayLogApi~apiPerplayLogNftDisassembleLogListPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/LogControllerDtoNftDisassembleLogListResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/LogControllerDtoNftDisassembleLogListRequest} [logControllerDtoNftDisassembleLogListRequest] 
     * @param {module:api/PerplayLogApi~apiPerplayLogNftDisassembleLogListPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/LogControllerDtoNftDisassembleLogListResponse}
     */
    apiPerplayLogNftDisassembleLogListPost(opts, callback) {
      opts = opts || {};
      let postBody = opts['logControllerDtoNftDisassembleLogListRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = LogControllerDtoNftDisassembleLogListResponse;
      return this.apiClient.callApi(
        '/api/PerplayLog/NftDisassembleLogList', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiPerplayLogNftRepairLogListPost operation.
     * @callback module:api/PerplayLogApi~apiPerplayLogNftRepairLogListPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/LogControllerDtoNftRepairLogListResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/LogControllerDtoNftRepairLogListRequest} [logControllerDtoNftRepairLogListRequest] 
     * @param {module:api/PerplayLogApi~apiPerplayLogNftRepairLogListPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/LogControllerDtoNftRepairLogListResponse}
     */
    apiPerplayLogNftRepairLogListPost(opts, callback) {
      opts = opts || {};
      let postBody = opts['logControllerDtoNftRepairLogListRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = LogControllerDtoNftRepairLogListResponse;
      return this.apiClient.callApi(
        '/api/PerplayLog/NftRepairLogList', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiPerplayLogNftRestoreLogListPost operation.
     * @callback module:api/PerplayLogApi~apiPerplayLogNftRestoreLogListPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/LogControllerDtoNftRestoreLogListResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/LogControllerDtoNftRestoreLogListRequest} [logControllerDtoNftRestoreLogListRequest] 
     * @param {module:api/PerplayLogApi~apiPerplayLogNftRestoreLogListPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/LogControllerDtoNftRestoreLogListResponse}
     */
    apiPerplayLogNftRestoreLogListPost(opts, callback) {
      opts = opts || {};
      let postBody = opts['logControllerDtoNftRestoreLogListRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = LogControllerDtoNftRestoreLogListResponse;
      return this.apiClient.callApi(
        '/api/PerplayLog/NftRestoreLogList', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiPerplayLogNftStoredPowersLogListPost operation.
     * @callback module:api/PerplayLogApi~apiPerplayLogNftStoredPowersLogListPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/LogControllerDtoNftStoredPowersLogListResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/LogControllerDtoNftStoredPowersLogListRequest} [logControllerDtoNftStoredPowersLogListRequest] 
     * @param {module:api/PerplayLogApi~apiPerplayLogNftStoredPowersLogListPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/LogControllerDtoNftStoredPowersLogListResponse}
     */
    apiPerplayLogNftStoredPowersLogListPost(opts, callback) {
      opts = opts || {};
      let postBody = opts['logControllerDtoNftStoredPowersLogListRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = LogControllerDtoNftStoredPowersLogListResponse;
      return this.apiClient.callApi(
        '/api/PerplayLog/NftStoredPowersLogList', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiPerplayLogNftTransactionLogListPost operation.
     * @callback module:api/PerplayLogApi~apiPerplayLogNftTransactionLogListPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/LogControllerDtoNftTransactionLogListResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/LogControllerDtoNftTransactionLogListRequest} [logControllerDtoNftTransactionLogListRequest] 
     * @param {module:api/PerplayLogApi~apiPerplayLogNftTransactionLogListPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/LogControllerDtoNftTransactionLogListResponse}
     */
    apiPerplayLogNftTransactionLogListPost(opts, callback) {
      opts = opts || {};
      let postBody = opts['logControllerDtoNftTransactionLogListRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = LogControllerDtoNftTransactionLogListResponse;
      return this.apiClient.callApi(
        '/api/PerplayLog/NftTransactionLogList', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiPerplayLogNicknameChangeLogListPost operation.
     * @callback module:api/PerplayLogApi~apiPerplayLogNicknameChangeLogListPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/LogControllerDtoNicknameChangeLogListResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/LogControllerDtoNicknameChangeLogListRequest} [logControllerDtoNicknameChangeLogListRequest] 
     * @param {module:api/PerplayLogApi~apiPerplayLogNicknameChangeLogListPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/LogControllerDtoNicknameChangeLogListResponse}
     */
    apiPerplayLogNicknameChangeLogListPost(opts, callback) {
      opts = opts || {};
      let postBody = opts['logControllerDtoNicknameChangeLogListRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = LogControllerDtoNicknameChangeLogListResponse;
      return this.apiClient.callApi(
        '/api/PerplayLog/NicknameChangeLogList', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiPerplayLogPilotDisassembleLogListPost operation.
     * @callback module:api/PerplayLogApi~apiPerplayLogPilotDisassembleLogListPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/LogControllerDtoPilotDisassembleLogListResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/LogControllerDtoPilotDisassembleLogListRequest} [logControllerDtoPilotDisassembleLogListRequest] 
     * @param {module:api/PerplayLogApi~apiPerplayLogPilotDisassembleLogListPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/LogControllerDtoPilotDisassembleLogListResponse}
     */
    apiPerplayLogPilotDisassembleLogListPost(opts, callback) {
      opts = opts || {};
      let postBody = opts['logControllerDtoPilotDisassembleLogListRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = LogControllerDtoPilotDisassembleLogListResponse;
      return this.apiClient.callApi(
        '/api/PerplayLog/PilotDisassembleLogList', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiPerplayLogPilotEquipLogListPost operation.
     * @callback module:api/PerplayLogApi~apiPerplayLogPilotEquipLogListPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/LogControllerDtoPilotEquipLogListResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/LogControllerDtoPilotEquipLogListRequest} [logControllerDtoPilotEquipLogListRequest] 
     * @param {module:api/PerplayLogApi~apiPerplayLogPilotEquipLogListPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/LogControllerDtoPilotEquipLogListResponse}
     */
    apiPerplayLogPilotEquipLogListPost(opts, callback) {
      opts = opts || {};
      let postBody = opts['logControllerDtoPilotEquipLogListRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = LogControllerDtoPilotEquipLogListResponse;
      return this.apiClient.callApi(
        '/api/PerplayLog/PilotEquipLogList', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiPerplayLogPilotPromotionLogListPost operation.
     * @callback module:api/PerplayLogApi~apiPerplayLogPilotPromotionLogListPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/LogControllerDtoPilotPromotionLogListResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/LogControllerDtoPilotPromotionLogListRequest} [logControllerDtoPilotPromotionLogListRequest] 
     * @param {module:api/PerplayLogApi~apiPerplayLogPilotPromotionLogListPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/LogControllerDtoPilotPromotionLogListResponse}
     */
    apiPerplayLogPilotPromotionLogListPost(opts, callback) {
      opts = opts || {};
      let postBody = opts['logControllerDtoPilotPromotionLogListRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = LogControllerDtoPilotPromotionLogListResponse;
      return this.apiClient.callApi(
        '/api/PerplayLog/PilotPromotionLogList', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiPerplayLogPilotSkillChangeLogListPost operation.
     * @callback module:api/PerplayLogApi~apiPerplayLogPilotSkillChangeLogListPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/LogControllerDtoPilotSkillChangeLogListResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/LogControllerDtoPilotSkillChangeLogListRequest} [logControllerDtoPilotSkillChangeLogListRequest] 
     * @param {module:api/PerplayLogApi~apiPerplayLogPilotSkillChangeLogListPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/LogControllerDtoPilotSkillChangeLogListResponse}
     */
    apiPerplayLogPilotSkillChangeLogListPost(opts, callback) {
      opts = opts || {};
      let postBody = opts['logControllerDtoPilotSkillChangeLogListRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = LogControllerDtoPilotSkillChangeLogListResponse;
      return this.apiClient.callApi(
        '/api/PerplayLog/PilotSkillChangeLogList', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiPerplayLogPowerChargeLogListPost operation.
     * @callback module:api/PerplayLogApi~apiPerplayLogPowerChargeLogListPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/LogControllerDtoPowerChargeLogListResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/LogControllerDtoPowerChargeLogListRequest} [logControllerDtoPowerChargeLogListRequest] 
     * @param {module:api/PerplayLogApi~apiPerplayLogPowerChargeLogListPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/LogControllerDtoPowerChargeLogListResponse}
     */
    apiPerplayLogPowerChargeLogListPost(opts, callback) {
      opts = opts || {};
      let postBody = opts['logControllerDtoPowerChargeLogListRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = LogControllerDtoPowerChargeLogListResponse;
      return this.apiClient.callApi(
        '/api/PerplayLog/PowerChargeLogList', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiPerplayLogResetStatsLogListPost operation.
     * @callback module:api/PerplayLogApi~apiPerplayLogResetStatsLogListPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/LogControllerDtoResetStatsLogListResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/LogControllerDtoResetStatsLogListRequest} [logControllerDtoResetStatsLogListRequest] 
     * @param {module:api/PerplayLogApi~apiPerplayLogResetStatsLogListPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/LogControllerDtoResetStatsLogListResponse}
     */
    apiPerplayLogResetStatsLogListPost(opts, callback) {
      opts = opts || {};
      let postBody = opts['logControllerDtoResetStatsLogListRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = LogControllerDtoResetStatsLogListResponse;
      return this.apiClient.callApi(
        '/api/PerplayLog/ResetStatsLogList', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiPerplayLogRollRandomGemSocketsLogListPost operation.
     * @callback module:api/PerplayLogApi~apiPerplayLogRollRandomGemSocketsLogListPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/LogControllerDtoRollRandomGemSocketsLogListResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/LogControllerDtoRollRandomGemSocketsLogListRequest} [logControllerDtoRollRandomGemSocketsLogListRequest] 
     * @param {module:api/PerplayLogApi~apiPerplayLogRollRandomGemSocketsLogListPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/LogControllerDtoRollRandomGemSocketsLogListResponse}
     */
    apiPerplayLogRollRandomGemSocketsLogListPost(opts, callback) {
      opts = opts || {};
      let postBody = opts['logControllerDtoRollRandomGemSocketsLogListRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = LogControllerDtoRollRandomGemSocketsLogListResponse;
      return this.apiClient.callApi(
        '/api/PerplayLog/RollRandomGemSocketsLogList', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiPerplayLogSpecialBoxLogListPost operation.
     * @callback module:api/PerplayLogApi~apiPerplayLogSpecialBoxLogListPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/LogControllerDtoSpecialBoxLogListResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/LogControllerDtoSpecialBoxLogListRequest} [logControllerDtoSpecialBoxLogListRequest] 
     * @param {module:api/PerplayLogApi~apiPerplayLogSpecialBoxLogListPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/LogControllerDtoSpecialBoxLogListResponse}
     */
    apiPerplayLogSpecialBoxLogListPost(opts, callback) {
      opts = opts || {};
      let postBody = opts['logControllerDtoSpecialBoxLogListRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = LogControllerDtoSpecialBoxLogListResponse;
      return this.apiClient.callApi(
        '/api/PerplayLog/SpecialBoxLogList', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiPerplayLogTransactionAttemptLogListPost operation.
     * @callback module:api/PerplayLogApi~apiPerplayLogTransactionAttemptLogListPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/LogControllerDtoTransactionAttemptLogListResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/LogControllerDtoTransactionAttemptLogListRequest} [logControllerDtoTransactionAttemptLogListRequest] 
     * @param {module:api/PerplayLogApi~apiPerplayLogTransactionAttemptLogListPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/LogControllerDtoTransactionAttemptLogListResponse}
     */
    apiPerplayLogTransactionAttemptLogListPost(opts, callback) {
      opts = opts || {};
      let postBody = opts['logControllerDtoTransactionAttemptLogListRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = LogControllerDtoTransactionAttemptLogListResponse;
      return this.apiClient.callApi(
        '/api/PerplayLog/TransactionAttemptLogList', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiPerplayLogWalletConnectionLogListPost operation.
     * @callback module:api/PerplayLogApi~apiPerplayLogWalletConnectionLogListPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/LogControllerDtoWalletConnectionLogListResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/LogControllerDtoWalletConnectionLogListRequest} [logControllerDtoWalletConnectionLogListRequest] 
     * @param {module:api/PerplayLogApi~apiPerplayLogWalletConnectionLogListPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/LogControllerDtoWalletConnectionLogListResponse}
     */
    apiPerplayLogWalletConnectionLogListPost(opts, callback) {
      opts = opts || {};
      let postBody = opts['logControllerDtoWalletConnectionLogListRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = LogControllerDtoWalletConnectionLogListResponse;
      return this.apiClient.callApi(
        '/api/PerplayLog/WalletConnectionLogList', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiPerplayLogWalletTransactionLogListPost operation.
     * @callback module:api/PerplayLogApi~apiPerplayLogWalletTransactionLogListPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/LogControllerDtoWalletTransactionLogListResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/LogControllerDtoWalletTransactionLogListRequest} [logControllerDtoWalletTransactionLogListRequest] 
     * @param {module:api/PerplayLogApi~apiPerplayLogWalletTransactionLogListPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/LogControllerDtoWalletTransactionLogListResponse}
     */
    apiPerplayLogWalletTransactionLogListPost(opts, callback) {
      opts = opts || {};
      let postBody = opts['logControllerDtoWalletTransactionLogListRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = LogControllerDtoWalletTransactionLogListResponse;
      return this.apiClient.callApi(
        '/api/PerplayLog/WalletTransactionLogList', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }


}
